import { StyledContainer, LoadingPulse, BricsContainer } from "./styles";

const LoaderBricks = () => {
  return (
    <StyledContainer>
      <LoadingPulse>
        <BricsContainer data-testid="loaderBricks-container">
          <div />
          <div />
          <div />
        </BricsContainer>
      </LoadingPulse>
    </StyledContainer>
  );
};

export default LoaderBricks;
